import React, { useEffect, useState } from 'react';
import { ModalContext } from '../Modal/modalContext';
import WishlistModal from './WishlistModal';
import { hasWishlistItems } from '../../functions';
import styles from './../../views/header.module.scss';

const WishlistButton = ({ customClassName, children, onClickHandler = (_) => {} }) => {
  let { handleModal } = React.useContext(ModalContext);
  const [isWishlistEmpty, setIsWishlistEmpty] = useState([]);

  useEffect((_) => {
    if (isWishlistEmpty) setIsWishlistEmpty(!hasWishlistItems());

    const localStorageSetHandler = () => {
      if (isWishlistEmpty) setIsWishlistEmpty(!hasWishlistItems());
    };

    document.addEventListener('itemInserted', localStorageSetHandler, false);
    return (_) => {
      document.removeEventListener('itemInserted', localStorageSetHandler, false);
    };
  }, []);

  return (
    <button
      className={`${customClassName} ${isWishlistEmpty ? '' : styles.activeWishlist}`}
      onClick={() => {
        handleModal(<WishlistModal />);
        onClickHandler();
      }}
    >
      {children}
    </button>
  );
};

export default WishlistButton;
